/**
 * Key type identifiers with their corresponding HSM specifier values
 * @see https://ripsim.atlassian.net/browse/RSSD-1159
 */
export enum UtimacoKeySpecifier {
  /**
   * ZMK (non-exportable) key type
   */
  ZmkNonExportable = 1,

  /**
   * OP Key/TOP Key type
   */
  OpKeyTopKey = 2,

  /**
   * Encryption Keys
   */
  EncryptionKeys = 3,

  /**
   * Master key for HTTP-OTA Derivation (HKDF)
   */
  MasterKeyHttpOtaDerivationHkdf = 4,

  /**
   * Master Key for SMS-OTA Derivation
   */
  MasterKeySmsOtaDerivation = 5,

  /**
   * Master key for ADM1 derivation (AES-ECB, no salt)
   */
  MasterKeyAdmDerivation = 6
}
